import { select } from "../core/dom";

const CIRCLE_LENGTH = 132;

export function initBackToTop(): void {
  const button = select<HTMLButtonElement>(".back-to-top");
  const progressCircle = select<SVGCircleElement>(
    ".back-to-top-progress circle",
    button ?? document
  );
  if (!button || !progressCircle) return;

  let scheduled = false;

  const update = (): void => {
    const scrollTop = window.scrollY;
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollableHeight > 0 ? scrollTop / scrollableHeight : 0;

    progressCircle.style.strokeDashoffset = String(CIRCLE_LENGTH - CIRCLE_LENGTH * progress);
    button.classList.toggle("is-visible", scrollTop > 500);
    scheduled = false;
  };

  const scheduleUpdate = (): void => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  button.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
  update();
}
